// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

	if(innerWidth < 600 && document.querySelector('.privary-navigation__submenu')){
		// document.querySelectorAll('.privary-navigation__submenu').forEach((submenu)=>{
		// 	submenu.classList.add('hidden');
		// });

		let openNavs = document.querySelectorAll('.js-open-sub');

		openNavs.forEach((button)=>{
			button.addEventListener('click',(e)=>{
				e.preventDefault();
				openNavs.forEach((button2)=>{
					button2.classList.remove('active');
					button2.nextElementSibling.classList.remove('show');
				})
				button.classList.toggle('active');
				button.nextElementSibling.classList.toggle('show');
			})
		})
	}else{
		let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
		itemsMenu.forEach((itemMenu)=>{
			if(itemMenu.querySelector('.submenu')){
				itemMenu.addEventListener('mouseenter',()=>{
					itemMenu.classList.add('hover');
					itemMenu.querySelector('.submenu').classList.add('show');
				});
				itemMenu.addEventListener('mouseleave',()=>{
					itemMenu.classList.remove('hover');
					itemMenu.querySelector('.submenu').classList.remove('show');
				})
			}
		})
	}

    window.onload = function() {
		scrollW();
		if(document.getElementById('home')){
			scrollDownAction(60, 'scroll');
		}
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

	if(document.getElementById('email-signup')){
		let buttonSingUp = document.querySelector('#email-signup .signup-btn');
		document.querySelector('.email-signup .fields-wrap').insertAdjacentElement('beforeend', buttonSingUp);
	}

	document.querySelectorAll('.btn:not(.reset), .btn-white').forEach((button)=>{
		let textButton = button.textContent;
		let spanbtn = document.createElement('span');
		button.textContent = '';
		spanbtn.textContent = textButton;
		button.insertAdjacentElement('afterbegin', spanbtn);
	});
	
	setTimeout(() => {
		if(document.querySelector('.btn-booking-cms')){
			document.querySelectorAll('.btn-booking-cms').forEach((button)=>{
				let textButton = button.firstChild.nodeValue.trim();
				let spanbtn = document.createElement('span');
				button.textContent = '';
				spanbtn.textContent = textButton;
				button.insertAdjacentElement('afterbegin', spanbtn);
				let supBtn = document.createElement('sup');
				supBtn.classList.add('hidden');
				supBtn.textContent = '(opens in new window)';
				button.insertAdjacentElement('beforeend', supBtn);
		});
		}
	}, 500);

	if(document.querySelector('.form-module-wrapper')){
		document.querySelectorAll('.form-module-wrapper').forEach((text) => {
			text.querySelector('.form-module').classList.add('animate-fade','top');
		});
	}

	if(document.querySelector('.text-modules-wrapper')){
		document.querySelectorAll('.text-modules-wrapper').forEach((text) => {
		text.querySelector('.text-modules').classList.add('animate-fade','top');
	});
	}

	if(document.querySelector('.global-sitemap')){
		document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');
	}
	

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	document.querySelector('#menu-site .js-close-menu').addEventListener('click', ()=>{
		document.getElementById('menu-site').classList.remove('show');
	})

	document.querySelector('.js-open-menu').addEventListener('click', ()=>{
		document.getElementById('menu-site').classList.add('show');	
	})

	document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.accordion').forEach((accordion) => {
            accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
                itemHead.addEventListener('click', (e) => {
                    accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
                        if (itemHead.parentNode !== item) item.classList.remove('open');
                    });
                    itemHead.parentNode.classList.toggle('open');
                });
            });
        });
    });

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

/** ADA Functionality for Keyboard Navigation in Menu & Website **/

const menu = document.querySelector('#menu-site');
const closeMenuButton = document.querySelector('.js-close-menu');

function handleLastItemTab(e) {
  if (e.key === 'Tab' && !e.shiftKey) { 
    e.preventDefault();
    if (closeMenuButton) closeMenuButton.focus(); 
  }
}

function updateMenuTabIndex() {
  if (!menu) return;
  const isMenuVisible = menu.classList.contains('show');
  const elements = menu.querySelectorAll('.privary-navigation__item a, .secondary-navigation__item a, .address a, .social-media a, .js-close-menu');
  const elementsToHide = document.querySelectorAll('.header__left a.phone, .header__logo, .bookingCMS');

  const tabValue = isMenuVisible ? '0' : '-1';
  const hideTabValue = isMenuVisible ? '-1' : '0';

  elements.forEach((element, index) => {
    element.setAttribute('tabindex', tabValue);

    if (index === elements.length - 1) {
      element.removeEventListener('keydown', handleLastItemTab);
      if (isMenuVisible) {
        element.addEventListener('keydown', handleLastItemTab);
      }
    }
  });

  elementsToHide.forEach(el => el.setAttribute('tabindex', hideTabValue));
}

document.addEventListener('DOMContentLoaded', () => {
  updateMenuTabIndex();
  if (menu) {
    menu.addEventListener('transitionend', updateMenuTabIndex);
  }

  if (closeMenuButton) {
    closeMenuButton.addEventListener('click', () => {
      const firstHeaderElement = document.querySelector('.header__left a.phone');
      if (firstHeaderElement) firstHeaderElement.focus();
    });
  }
});

document.addEventListener('keyup', (e) => {       
  if (e.key === 'Tab') { 
    const skipLink = document.querySelector('.skip-to-content');   
    if(skipLink && !skipLink.dataset.focused) { 
      skipLink.focus(); 
      skipLink.dataset.focused = "true";
    }         
  }
});

/** End of ADA Functionality for Keyboard Navigation **/